import { render, staticRenderFns } from "./CommonDescription.vue?vue&type=template&id=7f74cd04&scoped=true"
import script from "./CommonDescription.vue?vue&type=script&lang=js"
export * from "./CommonDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f74cd04",
  null
  
)

export default component.exports